import templateUrl from './display-options.html';

export const displayUserOptionsComponent = {
    bindings: {
        user: '<'
    },
    templateUrl,
    controller: class DisplayUserOptionsComponent {
        $onChanges(changes) {
            this.userType = changes.user.currentValue || 'All';
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/display-users-options/display-options.components.js